module.exports = {
	"permanent": "영구적인",
	"buttons": {
		"cancel": "취소",
		"close": "닫기",
		"copy": "복사",
		"copyFile": "파일 복사",
		"copyToClipboard": "클립보드로 복사",
		"create": "생성",
		"delete": "삭제",
		"download": "다운로드",
		"info": "정보",
		"more": "더보기",
		"move": "이동",
		"moveFile": "파일 이동",
		"new": "새로운 파일",
		"next": "다음",
		"ok": "확인",
		"replace": "대체",
		"previous": "이전",
		"rename": "이름 바꾸기",
		"reportIssue": "이슈 보내기",
		"save": "저장",
		"search": "검색",
		"select": "선택",
		"share": "공유",
		"publish": "퍼블리쉬",
		"selectMultiple": "다수 선택하기",
		"schedule": "스케쥴",
		"switchView": "뷰 전환",
		"toggleSidebar": "사이드바 토글",
		"update": "업데이트",
		"upload": "업로드",
		"permalink": "영구적인 링크 얻기"
	},
	"success": {
		"linkCopied": "링크가 복사되었습니다!"
	},
	"errors": {
		"forbidden": "허가되지 않은 접속입니다!",
		"internal": "먼가 오류가 있네요?!",
		"notFound": "해당 경로를 찾을 수 없습니다."
	},
	"files": {
		"folders": "폴더",
		"files": "파일",
		"body": "본문",
		"clear": "클리어",
		"closePreview": "프리뷰 닫기",
		"home": "홈",
		"lastModified": "최종 수정 시간",
		"loading": "로딩중..",
		"lonely": "이곳은 쓸쓸하네요..",
		"metadata": "메타데이터",
		"multipleSelectionEnabled": "다수 선택하기 켜짐",
		"name": "이름",
		"size": "크기",
		"sortByName": "이름으로 정렬하기",
		"sortBySize": "크기로 정렬하기",
		"sortByLastModified": "최종 수정 시간으로 정렬하기"
	},
	"help": {
		"click": "파일이나 디렉토리를 선택해주세요.",
		"ctrl": {
			"click": "다수의 파일이나 디렉토리를 선택해주세요.",
			"f": "검색창 열기",
			"s": "현재 있는 곳의 파일이나 디렉토리를 다운로드 하기"
		},
		"del": "선택한 파일들 삭제하기",
		"doubleClick": "파일이나 디렉토리 열기",
		"esc": "선택 취소/프롬프트 닫기",
		"f1": "정보",
		"f2": "파일 이름 변경",
		"help": "도움(Help)"
	},
	"login": {
		"password": "비밀번호",
		"submit": "로그인",
		"username": "유저네임",
		"wrongCredentials": "유저네임 혹은 비밀번호가 올바르지 않습니다."
	},
	"prompts": {
		"copy": "복사",
		"copyMessage": "파일을 복사할 곳 정하기:",
		"currentlyNavigating": "현재 위치:",
		"deleteMessageMultiple": "{count} 개의 파일을 삭제하시겠습니까?",
		"deleteMessageSingle": "이 파일 혹은 디렉토리를 삭제하시겠습니까?",
		"deleteTitle": "파일 삭제",
		"displayName": "디스플레이 네임:",
		"download": "파일 다운로드",
		"downloadMessage": "다운로드 받고 싶은 포맷 설정.",
		"error": "에러 발생!",
		"fileInfo": "파일 정보",
		"filesSelected": "{count} 개의 파일이 선택되었습니다.",
		"lastModified": "최종 수정 시간",
		"move": "이동",
		"moveMessage": "이동시킬 곳을 알려주세요:",
		"newDir": "새 디렉토리",
		"newDirMessage": "새 디렉토리의 이름을 입력해주세요.",
		"newFile": "새 파일",
		"newFileMessage": "새 파일의 이름을 입력해주세요.",
		"numberDirs": "디렉토리 수",
		"numberFiles": "파일 수",
		"replace": "덮어쓰기(replace)",
		"replaceMessage": "동일 한 파일을 업로드하려고 합니다. 존재하는 파일을 덮어 씌울까요?\n",
		"rename": "이름 변경",
		"renameMessage": "새로운 이름을 알려주세요.",
		"show": "보기",
		"size": "크기",
		"schedule": "스케쥴",
		"scheduleMessage": "이 포스트를 공개할 시간을 알려주세요.",
		"newArchetype": "archetype에 기반한 포스트를 생성합니다. 파일은 컨텐트 폴더(content folder)에 생성됩니다."
	},
	"settings": {
		"admin": "관리자",
		"administrator": "관리자",
		"allowCommands": "명령어 실행",
		"allowEdit": "파일/디렉토리의 수정, 변경 또는 삭제를 허용합니다.",
		"allowNew": "파일/디렉토리의 생성을 허용합니다.",
		"allowPublish": "페이지(새글)를 생성하는 것을 허용합니다.",
		"avoidChanges": "(수정하기 싫으시면 그냥 놔두시면 됩니다)",
		"changePassword": "비밀번호 변경",
		"commands": "명령들",
		"commandsHelp": "named events안에서 실행될 커맨드를 설정할 수 있습니다. 한줄에 하나의 커맨드를 작성하실 수 있습니다. 이벤트가 저장 전 혹은 후를 핸들링 하는 것과 같이 파일과 관련있다면, \"FILE\" 환경 변수는 파일의 경로와 함께 사용하실 수 있습니다.\n",
		"commandsUpdated": "커맨드 업데이트 완료!",
		"customStylesheet": "사용자 설정 스타일시트",
		"examples": "예시",
		"globalSettings": "글로벌 설정",
		"language": "언어",
		"lockPassword": "유저가 패스워드를 변경하는 것을 방지합니다",
		"newPassword": "새로운 비밀번호",
		"newPasswordConfirm": "새로운 비밀번호 확인",
		"newUser": "새로운 유저",
		"password": "비밀번호",
		"passwordUpdated": "비밀번호 업데이트 완료!",
		"permissions": "권한",
		"permissionsHelp": "유저를 관리자로 만들거나 각 퍼미션을 선택해 줄 수 있습니다. 관리자를 선택하시면 다른 모든 옵션들이 자동으로 선택됩니다. 사용자 관리는 여전히 현재 관리자만 할 수 있습니다.\n",
		"profileSettings": "프로필 설정",
		"ruleExample1": "모든 폴더의 .으로 시작하는 파일의 접근을 방지합니다.(예 .git, .gitignore) (숨김파일 보기 방지)\n",
		"ruleExample2": "Caddyfile파일의 접근을 방지합니다.",
		"rules": "룰",
		"rulesHelp1": "각 유저별 룰을 허용/비허용 할지 정할 수 있습니다. 블락된 파일은 리스팅 되지 않고 유저들은 접근할 수 없습니다. 사용자의 접근 허용 범위와 관련해 정규표현식(regex)과 경로를 지원합니다.\n",
		"rulesHelp2": "각 룰은 한줄에 하나씩 작성되어야 하며 {0} 또는 {1}로 시작되어야 합니다. 만약 정규 표현식을 사용한 식이나 경로를 사용할 경우 {2}를 꼭 사용해야 합니다.\n",
		"scope": "범위",
		"settingsUpdated": "설정 업데이트 완료!",
		"user": "유저",
		"userCommands": "명령어들",
		"userCommandsHelp": "이 유저에게 허용시킬 커맨드를 스페이스로 구분해 입력해주세요. 예시:\n",
		"userCreated": "유저 생성됨!",
		"userDeleted": "유저 삭제됨!",
		"userManagement": "유저 관리",
		"username": "유저네임",
		"users": "유저",
		"userUpdated": "유저 정보 업데이트 완료!"
	},
	"sidebar": {
		"help": "도움(Help)",
		"logout": "로그아웃",
		"myFiles": "내 파일들",
		"newFile": "새로운 파일",
		"newFolder": "새로운 폴더",
		"settings": "설정",
		"siteSettings": "사이트 설정",
		"hugoNew": "Hugo New",
		"preview": "미리보기"
	},
	"search": {
		"images": "이미지",
		"music": "음악",
		"notSupportedCommand": "지원 되지 않은 커맨드입니다.",
		"pdf": "PDF",
		"pressToExecute": "엔터를 누르시면 실행합니다.",
		"pressToSearch": "엔터를 누르시면 검색됩니다.",
		"search": "검색...",
		"searchOrCommand": "커맨드를 검색하거나 실행합니다...",
		"searchOrSupportedCommand": "검색하거나 '$'를 앞에 붙여 지원되는 커맨드들을 사용해보세요:",
		"typeCommand": "엔터를 누르시면 실행합니다.",
		"typeSearch": "엔터를 누르시면 검색됩니다.",
		"types": "Types",
		"video": "비디오",
		"writeToSearch": "검색하고 싶은것을 적어주세요"
	},
	"languages": {
		"ar": "العربية",
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch",
		"ru": "Русский",
		"pl": "Polski",
		"ko": "한국어"
	},
	"time": {
		"unit": "Time Unit",
		"seconds": "초",
		"minutes": "분",
		"hours": "시",
		"days": "일"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ko.yaml
// module id = 299
// module chunks = 0